var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg09D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42857 10H14.0952H20.9762C21.6508 10 23 9.63636 23 8.18182C23 7.58853 22.6121 6.41445 21.0769 6.36523C21.0217 6.36346 20.9765 6.31835 20.9733 6.26321C20.8754 4.57452 18.3236 3.57489 16.7145 5.40043C16.6508 5.47271 16.5179 5.43093 16.5085 5.33502C16.384 4.06372 15.4638 2 12.4762 2C11.1428 2 8.49167 2.71032 8.42968 5.53492C8.42847 5.59014 8.38419 5.63619 8.32901 5.63846C7.49367 5.67288 6 6.14167 6 7.81818C6 8.54545 6.48571 10 8.42857 10Z",
    fill: "#737373",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85714 15H10.5238H18.619C19.4127 15 21 14.5455 21 12.7273C21 11.9833 20.5407 10.5086 18.72 10.456C18.6648 10.4544 18.6193 10.4091 18.6169 10.354C18.5236 8.21558 15.4704 6.94482 13.572 9.29114C13.5105 9.3672 13.3757 9.32582 13.3681 9.2283C13.2434 7.64499 12.1781 5 8.61905 5C7.04664 5 3.91657 5.89211 3.85798 9.44383C3.85707 9.49905 3.81254 9.54529 3.75735 9.54737C2.7781 9.58422 1 10.1647 1 12.2727C1 13.1818 1.57143 15 3.85714 15Z",
    fill: "#D9D9D9",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16L3 22",
    stroke: "#0284C7",
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16L8 22",
    stroke: "#0284C7",
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16L13 22",
    stroke: "#0284C7",
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg09D);
export default __webpack_public_path__ + "static/media/09d.198b7944729dbdcd9bc19e37ad0b14ab.svg";
export { ForwardRef as ReactComponent };